import { useEffect, useState } from "react"; 
import "./styles.css";
import { fetchAllUsers, UserProps } from "../../controller/usersController";
import {
  fetchAllTanks,
  fetchUnassignedTanks,
  SensorDataProps,
  TankDataProps,
  fetchAllTanksSensorData,
} from "../../controller/tankController";
import NavBar from "../../components/NavBar/NavBar";
import Header from "../../components/Header/Header";
import AddUser from "./add-user";
import UserDetails from "./user-details";
import { useLocation } from "react-router-dom";
import Footer from "../../components/Footer";

function User() {
  const [showMoreDetails, setShowMoreDetails] = useState<boolean>(false);
  const [showAddUser, setShowAddUser] = useState<boolean>(false);
  const [showMenu, setShowMenu] = useState(false);
  const [allUsers, setAllUsers] = useState<UserProps[]>([]);
  const [availableTanks, setAllAvailableTanks] = useState<TankDataProps[]>([]);
  const [userDetails, setUserDetails] = useState<UserProps | null>(null);
  const [allTanksSensorData, setAllTanksSensorData] = useState<
    SensorDataProps[]
  >([]);
  const [allTanks, setAllTanks] = useState<TankDataProps[]>([]);
  const [selectedUserTank, setSelectedUserTank] =
    useState<TankDataProps | null>(null);
  const [selectedUserSensorData, setSelectedUserSensorData] =
    useState<SensorDataProps | null>(null);
  const [isLoading, setIsLoading] = useState<boolean>(true);

  const location = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  useEffect(() => {
    const fetchData = async () => {
      setIsLoading(true);
      try {
        // Fetch all users
        const usersResponse = await fetchAllUsers();
        setAllUsers(usersResponse.data || []);
        console.log("Available users", usersResponse.data);

        // Fetch unassigned tanks
        const tanksResponse = await fetchUnassignedTanks();
        setAllAvailableTanks(tanksResponse.data || []);
        console.log("Available tanks", tanksResponse.data);

        // Fetch all tanks
        const allTanksResponse = await fetchAllTanks();
        setAllTanks(allTanksResponse.data || []);
        console.log("All tanks", allTanksResponse.data);

        // Fetch all sensor data
        const sensorDataResponse = await fetchAllTanksSensorData();
        setAllTanksSensorData(sensorDataResponse.data || []);
        console.log("All sensor data", sensorDataResponse.data);
      } catch (err) {
        console.error("Error:", err);
      } finally {
        setIsLoading(false);
      }
    };

    fetchData();
  }, []);

  const getLatestSensorData = (tankId: string): SensorDataProps | null => {
    const tankSensorData = allTanksSensorData.filter(
      (sensor) => sensor._tank === tankId
    );

    return tankSensorData.length > 0
      ? tankSensorData[tankSensorData.length - 1]
      : null;
  };

  const getTankData = (tankId: string): TankDataProps | null => {
    return allTanks.find((tank) => tank.tankUniqueId === tankId) || null;
  };

  const handleViewDetails = async (userId: number) => {
    try {
      const selectedUserData = allUsers[userId];
      setUserDetails(selectedUserData);

      const tankId = selectedUserData.assignedTank;

      const tankData = getTankData(tankId);
      setSelectedUserTank(tankData);

      const sensorData = getLatestSensorData(tankId);
      setSelectedUserSensorData(sensorData);

      setShowMoreDetails(true);
    } catch (err) {
      console.error("Error preparing user details:", err);
    }
  };

  const renderUsersTableContent = () => {
    if (isLoading) {
      return (
        <center>
          <h2>Loading...</h2>
        </center>
      );
    }
    
    if (!allUsers || allUsers.length === 0) {
      return (
        <center>
          <h2>No user found</h2>
        </center>
      );
    }
    
    return (
      <>
        {allUsers.map((data, index) => (
          <div
            key={index}
            className="user-table-row"
            onClick={() => handleViewDetails(index)}
          >
            <div id="serial">
              {data?.userId &&
                data.userId.toString().padStart(2, "0")}
            </div>
            <div id="">{data.firstName}</div>
            <div id="">{data.lastName}</div>
            <div>{data.assignedTank}</div>
            <div id="us-email">{data.email}</div>
            <div id="">{data.phoneNumber}</div>
            <div
              id="u-det"
              onClick={() => {
                handleViewDetails(index);
              }}
            >
              View Details
            </div>
          </div>
        ))}
      </>
    );
  };

  return (
    <div className="dashboard-wrapper" id="bin-wrapper">
      <NavBar hideNav={showMenu} />
      <div className="dashboard-content">
        <Header
          title="Users"
          setShowMenu={() => setShowMenu(!showMenu)}
          showMenu={showMenu}
        />
      </div>
      <div className="dashboard-content" id="user-containn">
        <div id="tank-container">
        </div>
        <div className="dashboard-container binn-content" id="tank-container">
          <div className="user-bottom">
            <div
              className="userTop-right"
              style={{ display: "flex", justifySelf: "flex-end" }}
            >
              <button
                className="add-bin-btn"
                onClick={() => setShowAddUser(true)}
              >
                <img src="./images/bin/add.svg" alt="+" />
                Add a new user
              </button>
            </div>
            <div className="user-table">
              <h2 className="table-title">Users Available</h2>
              <div className="user-table-header">
                <div id="numb">#</div>
                <div id="">First Name</div>
                <div id="">Last Name</div>
                <div>Tank ID</div>
                <div id="user-email">Email</div>
                <div id="">Phone Number</div>
                <div id=""></div>
              </div>
              <div className="user-table-content">
                {renderUsersTableContent()}
              </div>
            </div>
          </div>
          {showAddUser && (
            <AddUser
              showAddUser={showAddUser}
              setShowAddUser={setShowAddUser}
              availableTanks={availableTanks}
            />
          )}
          {showMoreDetails && userDetails && selectedUserTank && (
            <UserDetails
              showMoreDetails={showMoreDetails}
              setShowMoreDetails={setShowMoreDetails}
              userdetails={userDetails}
              tankData={selectedUserTank}
              tankSensorData={
                selectedUserSensorData || {
                  tankDataId: "",
                  _tank: "",
                  tankLevel: "",
                  tankTemperaure: "",
                  tankOrientation: "",
                  longitude: "",
                  latitude: "",
                  batteryLevel: "",
                }
              }
              tankId={selectedUserTank.tankUniqueId}
              tankSize={selectedUserTank.tankVolume}
            />
          )}
        </div>
      </div>
      <div className="footer-cont" id="user-footer-cont">
        <Footer />
      </div>
    </div>
  );
}

export default User;